<div class="selector-container">
  <span>Default Map</span> <app-slide-toggle #toggle (change)="toggleStyle($event)"></app-slide-toggle> <span>Flat Map</span>
</div>
